export default () => {
    const and_ua = navigator.userAgent;
    if( and_ua.indexOf("Android") > 0 ) {
        const version = parseFloat(and_ua.slice(and_ua.indexOf("Android")+8));
        return version;
    }
}